<template>
    <v-container fluid fill-height>
        <v-layout flex align-center justify-center>
            <v-card class="rounded-xxl" elevation="8"
                    :style="{'background-image': 'url(' + require('./../assets/banner.png') + ')', 'background-size': 'cover', 'background-position': 'center', 'min-width': '500px', 'width': '30%'}">
                <v-card-title class="pb-2 pt-2 primary white--text">
                    <v-icon left color="white">mdi-lock-open-outline</v-icon>
                    CopNET - Anmelden
                </v-card-title>
                <div v-if="success">
                    <v-card-text>
                        <v-alert type="success" class="rounded-xl">
                            Du wurdest erfolgreich eingeloggt! <br/>
                            Willkommen <b>{{ user.displayName }}</b>
                        </v-alert>
                    </v-card-text>
                </div>
                <div v-else>
                    <v-card-text class="pt-5 pb-0">
                        <v-text-field label="Deine Dienstnummer (z.B.: DRK-01)" v-model="username" required
                                      background-color="rgba(255, 255, 255, 0.7)"
                                      solo dense outlined autocomplete="username webauthn"
                                      prepend-inner-icon="mdi-account"
                                      @keydown.enter="signIn" :error="error"/>

                        <v-text-field label="Dein Passwort" v-model="password" min="8"
                                      background-color="rgba(255, 255, 255, 0.7)"
                                      prepend-inner-icon="mdi-form-textbox-password"
                                      :append-icon="hiddenPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                                      :type="hiddenPassword ? 'password' : 'text'" counter required
                                      solo dense outlined
                                      @click:append="hiddenPassword = !hiddenPassword" @keydown.enter="signIn"
                                      :error="error"/>

                        <v-text-field v-if="playerIdentifier" label="Spieler Identifier"
                                      v-model="playerIdentifier" disabled
                                      solo dense outlined/>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <v-btn class="rounded-xl" :color="loginButtonColor" @click="signIn" :loading="loading">
                            <v-icon left>mdi-login-variant</v-icon>
                            Anmelden
                        </v-btn>
                        <v-spacer/>
                        <v-btn class="rounded-xl" :color="loginButtonColor" @click="signInWithWebAuthn"
                               :loading="loading">
                            <v-icon left>mdi-key</v-icon>
                            WebAuthn
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-layout>
    </v-container>
</template>

<style>

</style>

<script>
import * as webauthnJson from '@github/webauthn-json'
import axios from 'axios'

export default {
    data: () => ({
        username: '',
        password: '',
        playerIdentifier: null,

        loading: false,
        success: false,
        error: null,

        hiddenPassword: true,
    }),
    computed: {
        loginButtonColor() {
            if (this.error) {
                return 'error';
            }
            return 'primary';
        }
    },
    methods: {
        async validateSessionAndRedirect() {
            this.playerIdentifier = this.$route.query.playerIdentifier;

            if (!this.isAuthenticated || !this.user?.accountType) {
                return;
            }

            try {
                const response = await axios.get(this.$SERVER_URL + '/api/security/@me', {withCredentials: true});
                this.$store.commit('update', {user: response.data});
                this.$router.push('/dashboard-' + response.data.accountType.toLowerCase());
            } catch (e) {
                // Local persisted user can be stale after backend restarts; keep user on login.
                this.$store.commit('update', {user: null});
                this.updateVuetifyTheme();
            }
        },
        async signInWithWebAuthn() {
            const credentialGetOptions = await this.apiWebAuthnAssertionStart()
            const credentials = await webauthnJson.get(credentialGetOptions.data)

            const response = await this.apiWebAuthnAssertionComplete(credentials);

            if (response.data.status === 'OK' && response.data.user) {
                this.$store.commit('update', {user: response.data.user})
                this.success = true;
                this.updateVuetifyTheme();
            }
        },
        async signIn() {
            if (this.loading || this.success) return;

            this.loading = true;
            this.error = null;

            this.$store.commit('update', {
                'passwordComplexity': this.calculatePasswordComplexity(this.password),
            });

            this.apiSignIn(this.username, this.password, this.playerIdentifier).then(response => {
                this.$store.commit('update', {user: response.data})
                this.success = true;
                this.updateVuetifyTheme();

                setTimeout(() => {
                    if (this.$route.path === '/')
                        this.$router.push('/dashboard-' + response.data.accountType.toLowerCase())
                }, 2000);
            }).catch(error => {
                this.error = error;
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    mounted() {
        this.validateSessionAndRedirect();
    }
}
</script>